import { gsap } from "gsap";
import { Flip } from "gsap/Flip";
import { Controller } from "@hotwired/stimulus";

gsap.registerPlugin(Flip);

// Connects to data-controller="flip"
export default class extends Controller {
  static targets = ["destination"];

  connect() {
    // console.log("Flip controller connected");
  }

  flip(event) {
    const source = event.currentTarget;
    // console.log("Source element:", source);
    const destination = this.destinationTarget;
    // console.log("Destination element:", destination);

    const state = Flip.getState(source);
    // console.log("Flip state:", state);

    destination.appendChild(source);

    // // Perform the flip animation
    // gsap.to(destination, {
    //   duration: 0.5,
    //   ease: "power1.inOut",
    //   onStart: () => {
    //     destination.style.display = "block";
    //     destination.style.opacity = 0;
    //   },
    //   onComplete: () => {
    //     destination.style.opacity = 1;
    //   },
    // });

    Flip.to(state, {
      duration: 0.5,
      ease: "power1.inOut",
      onComplete: () => {
        // console.log("Flip animation completed");
      },
    });
    // Flip.fit(source, destination, {
    //   duration: 0.5,
    //   ease: "power1.inOut",
    //   onStart: () => {
    //     destination.style.display = "block";
        
    //   },
    //   onComplete: () => {
    //     console.log("Flip animation completed");
    //   },
    //   onReverseComplete: () => {
    //     console.log("Flip animation reversed");
    //     destination.style.display = "none";
    //   }
    // })
  }
}
